import { ColorConvertible } from '@yfiles/yfiles';

/**
 * Color constants for the Orbus Stream Navigator Component
 */

// Heat map colors
export const HEAT_MAP = {
  // Fill colors (backgrounds)
  FILL: {
    GOOD: '#E9FFE6',   // Light green background
    WARNING: '#ffffe5', // Light yellow background
    BAD: '#fbe7e7',    // Light red background
    DEFAULT: 'white'
  },
  
  // Stroke colors (borders)
  STROKE: {
    GOOD: '#58B74E',   // Green border
    WARNING: '#fff047', // Yellow border
    BAD: '#CF2F34',    // Red border
    DEFAULT: '#d2d0ce'
  },
  
  // Text colors
  TEXT: {
    GOOD: '#0F7F02',   // Green text
    WARNING: '#ffd268', // Yellow text
    BAD: '#CF2F34',    // Red text
    DEFAULT: '#605e5c'
  }
};

// Node colors
export const NODE = {
  FILL: {
    DEFAULT: 'white',
    TEAM: '#FAF9F8',
    CAPABILITY: '#FAF9F8'
  },
  STROKE: {
    DEFAULT: '#d2d0ce',
    TEAM: '#d2d0ce',
    CAPABILITY: '#A19F9D',
    APPLICATION: '#A19F9D'
  }
};

// Text colors
export const TEXT = {
  DARK: '#323130',
  MEDIUM: '#605e5c',
  LIGHT: 'white'
};

// UI colors
export const UI = {
  BACKGROUND: {
    COLUMN_HEADER: '#edebe9',
    TRANSPARENT: 'transparent'
  },
  ICON: {
    FOREGROUND: '#151E47'
  },
  HIGHLIGHT: {
    SEARCH: 'orange'
  }
};

// Product colors - for product nodes and edges
export const PRODUCT_COLORS = [
  '#F44336', // Red
  '#FF9900', // Orange
  '#0072C6', // Blue
  '#44A047', // Green
  '#8C6239', // Brown
  '#64B5F6', // Light blue
  '#01A99D', // Teal
  '#999999', // Gray
  '#FFCC80', // Light orange
  '#C62828', // Dark red
  '#4050B5', // Indigo
  '#01695C', // Dark teal
  '#5D4037', // Dark brown
  '#EE9999', // Pink
  '#EF6C00'  // Dark orange
];

// Lighter versions of product colors
export const PRODUCT_COLORS_LIGHT = [
  '#FFCDD2', // lighter Red
  '#FFE0B2', // lighter Orange
  '#BBDEFB', // lighter Blue
  '#C8E6C9', // lighter Green
  '#D7CCC8', // lighter Brown
  '#E3F2FD', // lighter Light blue
  '#B2DFDB', // lighter Teal
  '#F5F5F5', // lighter Gray
  '#FFF3E0', // lighter Light orange
  '#FFCDD2', // lighter Dark red
  '#C5CAE9', // lighter Indigo
  '#B2DFDB', // lighter Dark teal
  '#EFEBE9', // lighter Dark brown
  '#FFEBEE', // lighter Pink
  '#FFE0B2'  // lighter Dark orange
];

// 3D node colors
export const NODE_3D = {
  DEFAULT: { r: 200, g: 200, b: 200, a: 190 },
  HIGHLIGHTED: { r: 150, g: 150, b: 150, a: 150 }
};

// Edge colors
export const EDGE = {
  BACKGROUND: 'white'
};

// Type definitions for heatmap colors
export type HeatMapColor = 'GOOD' | 'WARNING' | 'BAD';

// Mapping functions for heatmap colors
export const heatMapFills: Record<HeatMapColor, ColorConvertible> = {
  GOOD: HEAT_MAP.FILL.GOOD,
  WARNING: HEAT_MAP.FILL.WARNING,
  BAD: HEAT_MAP.FILL.BAD
};

export const heatMapStrokes: Record<HeatMapColor, ColorConvertible> = {
  GOOD: HEAT_MAP.STROKE.GOOD,
  WARNING: HEAT_MAP.STROKE.WARNING,
  BAD: HEAT_MAP.STROKE.BAD
};

export const heatMapLabelFill: Record<HeatMapColor, ColorConvertible> = {
  GOOD: HEAT_MAP.TEXT.GOOD,
  WARNING: HEAT_MAP.TEXT.WARNING,
  BAD: HEAT_MAP.TEXT.BAD
};
